export default __webpack_public_path__ + "static/media/noun-crane-496204.dec2352d.svg";